import React from 'react';
import { View } from 'src/components/common';
import { connect } from 'react-redux';
import { Skeleton } from '@material-ui/lab';
import './styles.scss';
import { IAppState } from 'src/store';
const PartyPlaceholder: React.FC<Props> = () => {
  return (
    <View className={'cmp-deposition-detail'} isRow>
      <View align="center" justify="center">
        <Skeleton width="12px" height="20px" />
      </View>
      <View className={'cmp-deposition-detail__image--with-text'}>
        <View isRow justify="center">
          <Skeleton style={{ marginRight: 8 }} variant="circle" width="40px" height="40px" />
          <Skeleton width="160px" />
        </View>
        <Skeleton width="210px" />
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PartyPlaceholder);
